import React from 'react';
import cx from 'classnames';

import Container from '../container';

import styles from './style.module.scss';

interface Props {
  examName: string;
}

export default (props: Props) => {
  const blogUrl = () => {
    if (props.examName.indexOf('IELTS') !== -1) {
      return 'https://magoosh.com/ielts';
    } else {
      return `https://magoosh.com/${props.examName.toLowerCase()}`
    }
  };

  const trademarkDisclaimer = () => {
    if (props.examName === 'ACT') {
      return 'ACT® is a registered trademark of Educational Testing Service (ETS). This website is not endorsed or approved by ETS.';
    } else if (props.examName === 'GMAT') {
      return 'GMAT® is a registered trademark of the Graduate Management Admission Council®. The Graduate Management Admission Council® does not endorse, nor is it affiliated in any way with the owner or any content of this web site.';
    } else if (props.examName === 'GRE') {
      return 'GRE® is a registered trademark of Educational Testing Service (ETS). This website is not endorsed or approved by ETS.';
    } else if (props.examName === 'LSAT') {
      return 'This website is not endorsed or approved by LSAC. All actual LSAT® content reproduced within this work is used within the permission of Law School Admission Council, Inc., (LSAC) Box 40, Newtown, PA 18940, the copyright owner. LSAC does not review or endorse specific test-preparation materials, companies, or services, and inclusion of licensed LSAT content within this work does not imply the review or endorsement of LSAC. LSAT is a registered trademark of LSAC.';
    } else if (props.examName === 'SAT') {
      return 'SAT® is a registered trademark of the College Board, which was not involved in the production of, and does not endorse this product.';
    } else if (props.examName === 'TOEFL') {
      return 'Official TOEFL® questions used under license from ETS. All rights reserved. TOEFL® is a registered trademark of ETS in the United States and other countries.';
    } else {
      return 'Test names and other trademarks are the property of the respective trademark holders. None of the trademark holders are affiliated with Magoosh or this website.';
    }
  };

  const youtubeUrl = () => {
    if (props.examName === 'ACT' || props.examName === 'SAT') {
      return 'https://www.youtube.com/@MagooshHS';
    } else if (props.examName === 'GMAT') {
      return 'https://www.youtube.com/@MagooshGMAT';
    } else if (props.examName === 'GRE') {
      return 'http://www.youtube.com/@MagooshGRE';
    }  else if (props.examName.indexOf('IELTS') !== -1) {
      return 'https://www.youtube.com/@magooshielts6799';
    } else if (props.examName === 'LSAT') {
      return 'https://www.youtube.com/@magooshlsat3701';
    } else if (props.examName === 'MCAT') {
      return 'https://www.youtube.com/@magooshmcat2923';
    } else if (props.examName === 'TOEFL') {
      return 'https://www.youtube.com/@MagooshTOEFL';
    } else {
      return '';
    }
  };

  return (
    <div>
      <div className={styles.scallopedEdge} />

      <div style={{ background: '#472375' }}>
        <Container className="u-padding-V-xl">
          <div className="d-flex flex-column-reverse flex-lg-row gap-l">
            <div className={cx(styles.magooshOrigin, 'text-inter')} style={{ color: '#C8BDD6' }}>
              <span style={{ color: '#FFFFFF' }}><strong>Magoosh</strong></span> is a play on the Old Persian word magush, one who is highly learned, wise and generous.
            </div>

            <div className="d-flex flex-wrap flex-lg-nowrap" style={{ rowGap: 30 }}>
              <div className={styles.linkList}>
                <ul>
                  <li>Magoosh {props.examName}</li>
                  <li><a href="/">Home</a></li>
                  <li><a href="/terms">Terms of Use</a></li>
                  <li><a href="/sms_terms">SMS Terms</a></li>
                  <li><a href="/privacy">Privacy</a></li>
                  {props.examName === 'TOEFL' && <li><a href="/attributions">Attributions</a></li>}
                </ul>
              </div>

              <div className={styles.linkList}>
                <ul>
                  <li>Account</li>
                  <li><a href="/plans">Plans & Pricing</a></li>
                  <li><a href="/login">Login</a></li>
                  <li><a href="/forgot_password">Forgot Password</a></li>
                </ul>
              </div>

              <div className={styles.linkList}>
                <ul>
                  <li>Company</li>
                  <li><a href="https://magoosh.com">Company Home</a></li>
                  <li><a href="https://magoosh.com/partner-with-us">Partner With Us</a></li>
                  <li><a href="mailto:help@magoosh.com">help@magoosh.com</a></li>
                </ul>
              </div>

              <div className={styles.linkList}>
                <ul>
                  <li>Follow Us</li>
                  <li><a href={youtubeUrl()}>YouTube</a></li>
                  <li><a href={blogUrl()}>Blog</a></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column flex-lg-row gap-m u-margin-T-l">
            <div className="flex-none text-inter" style={{ color: '#C8BDD6', fontSize: 12 }}>
              © 2026 Magoosh
            </div>

            <div className="d-flex flex-1 justify-content-end text-inter" style={{ color: '#C8BDD6', fontSize: 12 }}>
              {trademarkDisclaimer()}
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};
